import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ButtonFilled, Text, Flex, Box, Grid, SvgIcon, AspectRatio } from 'Components/Base';
import { get as getTheme } from 'Components/Base/constants';

const Layout = styled((props) => (
  <Grid
    gridTemplateColumns={{ _: 'repeat(auto-fit, 100px)', md: 'repeat(auto-fit, 168px)' }}
    gridTemplateRows={{ _: '56px', md: '95px' }}
    gridGap={{ _: '15px', md: '24px' }}
    {...props}
  />
))`
  place-content: space-between;
`;

const ImageUploadButton = (props) => (
  <ButtonFilled
    height={'50px'}
    borderRadius={'8px'}
    color="coolGrey.grey3"
    textColor="primary"
    width={1}
    px={4}
    py={2}
    {...props}
  />
);

const RemoveImageIcon = styled((props) => (
  <SvgIcon icon={SvgIcon.ICON_LIST.CLOSE_CIRCLE} color="primary" size={20} {...props} />
))`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(40%, -40%);
  background: white;
  border-radius: 50%;
  cursor: pointer;
`;

const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid ${getTheme('colors.greyscale.grey4')};
`;

const AddImageBlock = styled((props) => (
  <Grid gridTemplateRows={{ _: '56px', md: '95px' }} {...props} />
))`
  place-items: center;
  border-radius: 8px;
  border: 1px dashed ${getTheme('colors.greyscale.grey4')};
  cursor: pointer;
  height: 100%;
`;

const ClearImageUpload = ({
  limit = 3,
  images,
  onAddImage = () => {},
  onRemoveImage = () => {},
}) => {
  if (!images || images.length === 0) {
    return (
      <ImageUploadButton onClick={onAddImage}>
        <Flex justifyContent="center" alignItems="center">
          <SvgIcon icon={SvgIcon.ICON_LIST.IMAGE_UPLOAD} />
          <Text ml={'6px'} color="inherit">
            เพิ่มรูป
          </Text>
        </Flex>
      </ImageUploadButton>
    );
  }

  return (
    <Layout>
      {Array.from({ length: limit }).map((e, index) => {
        const image = images[index];
        if (image) {
          return (
            <Box style={{ position: 'relative' }} width={1} height={'100%'} key={image}>
              <AspectRatio ratio={16 / 9}>
                <Image src={image} />
              </AspectRatio>
              <RemoveImageIcon onClick={() => onRemoveImage(index)} />
            </Box>
          );
        } else {
          return (
            <AddImageBlock key={index} onClick={onAddImage} color="text">
              <SvgIcon
                icon={SvgIcon.ICON_LIST.IMAGE_UPLOAD}
                width={25}
                height={25}
                style={{ opacity: 0.3 }}
              />
            </AddImageBlock>
          );
        }
      })}
    </Layout>
  );
};

ClearImageUpload.propTypes = {
  limit: PropTypes.number,
  images: PropTypes.arrayOf(PropTypes.string),
  onAddImage: PropTypes.func,
  onRemoveImage: PropTypes.func,
};
export default ClearImageUpload;
